var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.8484 15.1295L11.7175 11.0646C12.7992 9.8893 13.4639 8.33495 13.4639 6.62455C13.4634 2.96568 10.4497 0 6.73182 0C3.01395 0 0.000244141 2.96568 0.000244141 6.62455C0.000244141 10.2834 3.01395 13.2491 6.73182 13.2491C8.3382 13.2491 9.81153 12.6935 10.9688 11.7697L15.1158 15.8507C15.3178 16.0498 15.6459 16.0498 15.848 15.8507C16.0505 15.6517 16.0505 15.3286 15.8484 15.1295ZM6.73182 12.2299C3.58609 12.2299 1.03599 9.72029 1.03599 6.62455C1.03599 3.52881 3.58609 1.01923 6.73182 1.01923C9.87757 1.01923 12.4276 3.52881 12.4276 6.62455C12.4276 9.72029 9.87757 12.2299 6.73182 12.2299Z","fill":"#231F20"}));
}

Search.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Search;

Search.default = Search;
